/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const userDonationModelSchema = z.object({
    "userId": z.string().uuid().describe("Идентификатор пользователя").nullable().nullish(),
"nickname": z.string().describe("Пользователь").nullable().nullish(),
"amount": z.number().int().describe("Сумма платежа в копейках"),
"date": z.string().datetime({ offset: true }).describe("Дата платежа")
    })